var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_428_4117",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_428_4117)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9992 44.8C21.0659 44.8 18.3326 44.2667 15.7992 43.2C13.2659 42.1333 11.0659 40.6667 9.19922 38.8C7.33255 36.9333 5.86589 34.7333 4.79922 32.2C3.73255 29.6667 3.19922 26.9333 3.19922 24C3.19922 21.0667 3.73255 18.3333 4.79922 15.8C5.86589 13.2667 7.33255 11.0667 9.19922 9.2C11.0659 7.33333 13.2659 5.86666 15.7992 4.8C18.3326 3.73333 21.0659 3.2 23.9992 3.2C25.9992 3.2 27.9409 3.48333 29.8242 4.05C31.7076 4.61666 33.4826 5.45 35.1492 6.55C35.5826 6.81666 35.8492 7.19166 35.9492 7.675C36.0492 8.15833 35.9492 8.58333 35.6492 8.95C35.3492 9.38333 34.9492 9.625 34.4492 9.675C33.9492 9.725 33.4826 9.63333 33.0492 9.4C31.6826 8.56666 30.2326 7.93333 28.6992 7.5C27.1659 7.06666 25.5992 6.85 23.9992 6.85C19.1326 6.85 15.0576 8.49166 11.7742 11.775C8.49089 15.0583 6.84922 19.1333 6.84922 24C6.84922 28.8667 8.49089 32.9417 11.7742 36.225C15.0576 39.5083 19.1326 41.15 23.9992 41.15C28.8659 41.15 32.9409 39.5083 36.2242 36.225C39.5076 32.9417 41.1492 28.8667 41.1492 24C41.1492 23.4667 41.1242 22.95 41.0742 22.45C41.0242 21.95 40.9492 21.4667 40.8492 21C40.7826 20.4667 40.8826 19.9833 41.1492 19.55C41.4159 19.1167 41.7992 18.85 42.2992 18.75C42.7992 18.6167 43.2659 18.7 43.6992 19C44.1326 19.3 44.3826 19.7 44.4492 20.2C44.5492 20.8333 44.6326 21.4667 44.6992 22.1C44.7659 22.7333 44.7992 23.3667 44.7992 24C44.7992 26.9333 44.2659 29.6667 43.1992 32.2C42.1326 34.7333 40.6659 36.9333 38.7992 38.8C36.9326 40.6667 34.7326 42.1333 32.1992 43.2C29.6659 44.2667 26.9326 44.8 23.9992 44.8ZM21.0492 28.15L40.7992 8.45C41.1326 8.08333 41.5659 7.9 42.0992 7.9C42.6326 7.9 43.0992 8.08333 43.4992 8.45C43.8659 8.85 44.0492 9.30833 44.0492 9.825C44.0492 10.3417 43.8659 10.8 43.4992 11.2L22.3492 32.3C21.9826 32.6667 21.5492 32.85 21.0492 32.85C20.5492 32.85 20.1326 32.6667 19.7992 32.3L13.6492 26.1C13.2826 25.7667 13.1076 25.325 13.1242 24.775C13.1409 24.225 13.3326 23.7667 13.6992 23.4C14.0326 23.0667 14.4742 22.9 15.0242 22.9C15.5742 22.9 16.0326 23.0667 16.3992 23.4L21.0492 28.15Z",
    fill: "#07A217"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheck);
export default __webpack_public_path__ + "static/media/greenCheck.f01c7c7e4821605a3fd983a745bea02c.svg";
export { ForwardRef as ReactComponent };